//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PlanClient from 'scripts/clients/robox-api/PlanClient.js';
import moneyFormat from '../../../util/moneyFormat.js';

export default {
    name: 'PlanCards',
    props: {
        planDataPeriodAnnual: Object,
        planDataPeriodSemiannual: Object,
        planDataPeriodMonthly: Object,
        planCurrentPeriod: {
            type: String,
            required: true,
        },
        planType: {
            type: String,
            required: true,
        },
        planMascotsUrl: {
            type: String,
            required: true,
        },
    },
    data: () => {
        return {
            periodAnnual: 'annual',
            periodSemiannual: 'semiannual',
            periodMonthly: 'monthly',
            lang: {
                period: {
                    annual: 'Anual',
                    semiannual: 'Semestral',
                    monthly: 'Mensal',
                },
            },
            dataPeriodAnnual: {},
            dataPeriodSemiannual: {},
            dataPeriodMonthly: {},
        };
    },
    computed: {
        type: {
            get: function () {
                return `plan-${this.planType}`;
            },
        },
        planId: {
            get: function () {
                return this.dataCurrentPeriod.acf.plan_id
            },
        },
        mascotsUrl: {
            get: function () {
                return this.planMascotsUrl;
            },
        },
        title: {
            get: function () {
                return this.dataCurrentPeriod.acf.title;
            },
        },
        subtitle: {
            get: function () {
                return this.dataCurrentPeriod.acf.subtitle;
            },
        },
        amount: {
            get: function () {
                return this.dataCurrentPeriod.robox.price;
            },
        },
        feeAmount: {
            get: function () {
                let amount = this.amount;

                if (this.dataCurrentPeriod.acf.split_value) {
                    amount = Math.ceil(this.amount / this.dataCurrentPeriod.robox.orders_by_purchase);
                }

                return amount;
            },
        },
        amountReal: {
            get: function () {
                return moneyFormat(this.feeAmount).slice(0, -3);
            },
        },
        amountCents: {
            get: function () {
                return this.feeAmount.toString().slice(-2);
            },
        },
        period: {
            get: function () {
                let titlePeriod = '';

                if (this.dataCurrentPeriod.acf.time_unit_name.length > 0) {
                    titlePeriod = this.dataCurrentPeriod.acf.time_unit_name;
                } else if (this.dataCurrentPeriod.acf.split_value) {
                    titlePeriod = 'mês';
                } else {
                    switch (this.planCurrentPeriod) {
                        case this.periodAnnual:
                            titlePeriod = 'ano';
                            break;
                        case this.periodSemiannual:
                            titlePeriod = 'semestre';
                            break;
                        case this.periodMonthly:
                            titlePeriod = 'mês';
                            break;
                    }
                }

                titlePeriod = (titlePeriod.search('/') !== -1) ? titlePeriod : `/${titlePeriod}`;

                return titlePeriod;
            },
        },
        ctaUrl: {
            get: function () {
                return this.dataCurrentPeriod.acf.cta_url;
            },
        },
        ctaTitle: {
            get: function () {
                return this.dataCurrentPeriod.acf.cta_title;
            },
        },
        itemsList: {
            get: function () {
                return this.dataCurrentPeriod.acf.items_list
                    .map(function (value) {
                        return value.item;
                    });
            },
        },
        dataCurrentPeriod: {
            get: function () {
                return this.periodSwitchData(this.planCurrentPeriod);
            },
        },
    },
    watch: {
        dataPeriodAnnual : {
            handler: function () {
                if (this._objectIsEmpty(this.dataPeriodSemiannual)) {
                    this.requestPlanSemiannualData();
                }

                if (this._objectIsEmpty(this.dataPeriodMonthly)) {
                    this.requestPlanMonthlyData();
                }
            },
        },
    },
    methods: {
        periodSwitchData: function (period) {
            let dataPeriod = {};

            switch (period) {
                case this.periodAnnual:
                    dataPeriod = {
                        acf: this.planDataPeriodAnnual,
                        robox: this.dataPeriodAnnual,
                    };
                    break;
                case this.periodSemiannual:
                    dataPeriod = {
                        acf: this.planDataPeriodSemiannual,
                        robox: this.dataPeriodSemiannual,
                    };
                    break;
                case this.periodMonthly:
                    dataPeriod = {
                        acf: this.planDataPeriodMonthly,
                        robox: this.dataPeriodMonthly,
                    };
                    break;
            }

            return dataPeriod;
        },
        // redirectToCheckout: function () {
        redirectToCheckout: function (price) {
            // FIXME: ATENÇÃO!!! DEIXAR ISSO INATIVO EM STAGING

            // Google Analytics
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'addToCart',
                'ecommerce': {
                    'currencyCode': 'BRL',
                    'add': {                                // 'add' actionFieldObject measures.
                        'products': [{                        //  adding a product to a shopping cart.
                            'name': this.dataCurrentPeriod.robox.name,
                            'id': this.planId,
                            'price': price,
                            'quantity': 1,
                        }],
                    },
                },
            });

            // Facebook Pixel
            try {
                window.fbq('track', 'AddToCart', {currency: "BRL", value: price});
            } catch (err) {
                console.warn(err)
                // ignore analytics errors
            }

            window.location.href = `/flow/?plan_id=${this.planId}`;
        },
        requestPlanAnnualData: function () {
            const self = this;

            new PlanClient()
                .read(self.planDataPeriodAnnual.plan_id)
                .then(function(response) {
                    return response.json();
                })
                .then(function(data) {
                    self.dataPeriodAnnual = data.attributes;
                });
        },
        requestPlanSemiannualData: function () {
            const self = this;

            new PlanClient()
                .read(self.planDataPeriodSemiannual.plan_id)
                .then(function(response) {
                    return response.json();
                })
                .then(function(data) {
                    self.dataPeriodSemiannual = data.attributes;
                });
        },
        requestPlanMonthlyData: function () {
            const self = this;

            new PlanClient()
                .read(self.planDataPeriodMonthly.plan_id)
                .then(function(response) {
                    return response.json();
                })
                .then(function(data) {
                    self.dataPeriodMonthly = data.attributes;
                });
        },
        _objectIsEmpty(obj) {
            return (Object.keys(obj).length === 0);
        },
    },
    beforeCreate () {
    },
    created () {
        this.requestPlanAnnualData();
    },
    beforeMount () {
    },
    mounted () {
    },
    updated () {
    },
    beforeDestroy() {
    },
};



// WEBPACK FOOTER //
// ./scripts/vue/components/choose-plan/PlanCards.vue